import React, { FC, useState } from "react";
import { SearchInput } from "./SearchInput";
import { SearchResults } from "./SearchResults";
import { SearchParams } from "./SearchParams.csharp";
import { SearchResultItemViewModel } from "./SearchResultItemViewModel.csharp";
import { SearchApi } from "../Api/SearchApi";

const searchApi = new SearchApi();
export const Search: FC<SearchParams> = ({ query, searchUrl, placeholder }) => {
  const [items, setItems] = useState<SearchResultItemViewModel[]>([]);
  const [totalResults, setTotalResults] = useState(0);
  const [loading, setLoading] = useState(false);
  const fetchSearchData = () => {
    setLoading(true);
    searchApi
      .search(query, items?.length)
      .then((data) => {
        setTotalResults(data.totalCount);
        setItems([...items, ...data.items]);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <>
      <SearchInput
        query={query}
        placeholder={placeholder}
        searchUrl={searchUrl}
        loading={loading}
      />
      <SearchResults
        query={query}
        loading={loading}
        items={items}
        totalResults={totalResults}
        fetchSearchData={fetchSearchData}
      />
    </>
  );
};
